import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Theme, Notifications } from 'stylist'
import 'normalize.css'
import 'styles/global'
import { BrowserRouter } from 'react-router-dom'
import store from './config/store'
import { Provider } from 'react-redux'
import './config/sentry'

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <Theme>
        <Fragment>
          <Notifications />
          <App />
        </Fragment>
      </Theme>
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js